import { FormGroup, FormControl } from "@angular/forms";

export function validateLowercase(text: string): boolean {
    const regexp = new RegExp("(?=.*[a-z])");
    return regexp.test(text);
}

export function validateUppercase(text: string): boolean {
    const regexp = new RegExp("(?=.*[A-Z])");
    return regexp.test(text);
}

export function validatenumber(text: string): boolean {
    const regexp = new RegExp("(?=.*[0-9])");
    return regexp.test(text);
}

export function validateSpecialCharacter(text: string): boolean {
    const regexp = new RegExp("(?=.*[$@$!%*?&])");
    return regexp.test(text);
}

export function validateMinLength(text: string): boolean {    
    return text.length >= 8;
}